import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Radio,
  Input,
  message,
  Upload,
  Tag,
  Spin,
  Image,
} from "antd";
import inviteCapture from "../../Assets/InviteCapture/InviteCaptureFinal1.png";
import processInvite from "../../Assets/InviteCapture/process-invite.png";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  BellOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { URL } from "../../helper/Mainurl";
import {
  ColorLensOutlined,
  AssessmentOutlined,
  RepeatOnOutlined,
} from "@mui/icons-material";
import "./Invite.css";
import EditableField from "./EditableField";
import { LocationOn, TitleOutlined } from "@mui/icons-material";
import "../../App.css";
import DetailsList from "../DetailsList";
import Reminder from "../CalenderModal/Reminder";
import moment from "moment";
import CollaborationModal from "../CalenderModal/CollaborationModal";
import ColorsModal from "../CalenderModal/ColorsModal";
import RepeatModal from "../CalenderModal/RepeatModal";
import LearnMoreModal from "../../Components/LearnMore/LearnMoreModal";
import { set } from "lodash";

const InviteCapture = ({
  showModal,
  closeModal,
  getData,
  setSearchTerm,
  setDateRange,
  setSelectedTab,
}) => {
  const token = localStorage.getItem("authToken");

  const [imageUrl, setImageUrl] = useState(""); // Default image

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [descSelectedReminder, setDescSelectedReminder] =
    useState("No reminder");
  const [showRemModal, setShowRemModal] = useState(false);
  const [title, setTitle] = useState("");
  const [switchStatesRem, setSwitchStatesRem] = useState(false);
  const [uploadedData, setUploadedData] = useState([]); // Store uploaded response
  const [priority, setPriority] = useState([]);
  const [selectedPriorityIds, setSelectedPriorityIds] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [selectedReminder, setSelectedReminder] = useState("No reminder");
  const [uploadedPdf, setUploadedPdf] = useState(null);
  const [isUploading, setIsUploading] = useState(false); // ✅ Loader state
  const [selectedStatus, setSelectedStatus] = useState("pending confirmation"); // Default state
  const [radioMeta, setRadioMeta] = useState([]);
  const [formattedTime, setFormattedTime] = useState("");
  const [note, setNote] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [switchTimeStates, setSwitchTimeStates] = useState(false);
  const [location, setLocation] = useState("NA");
  const [userId, setUserId] = useState(null);
  const [showCollaborationModal, setShowCollaborationModal] = useState(false);
  const [showColorModal, setShowColorModal] = useState(false);
  const [showRepeatModal, setShowRepeatModal] = useState(false);

  const [selectedCollaborators, setSelectedCollaborators] = useState([]);
  // const [descSelectedCollaboration, setDescSelectedCollaboration] = useState("No participants selected");
  const [descSelectedColor, setDescSelectedColor] = useState("No color");
  const [selectedColorForPayload, setSelectedColorForPayload] = useState("");
  const [repeatConfig, setRepeatConfig] = useState(null);
  const [switchStatesCollaboration, setSwitchStatesCollaboration] =
    useState(false);
  const [switchStatesColor, setSwitchStatesColor] = useState(false);
  const [switchStatesRepeat, setSwitchStatesRepeat] = useState(false);
  const [descSelectedRepeat, setDescSelectedRepeat] = useState("No repeat");
  const [permission, setPermission] = useState([]);
  const [repeatOption, setRepeatOption] = useState([]);
  const [colorMetaData, setColorMetaData] = useState([]);
  const [adjusWeekend, setAdjustWeekend] = useState([]);
  const [invitees, setInvitees] = useState();
  const [activeTab, setActiveTab] = useState("1");
  const [AssignData, setAssignData] = useState([]);
  const [CollaborateData, setCollaborateData] = useState([]);
  const [dummyCollaborators, setDummyCollaborators] = useState([]);

  const [selectedTime, setSelectedTime] = useState({
    start: null,
    end: null,
  });

  const [fileUrl, setFileUrl] = useState("");

  const fetchCollabaroteDate = async () => {
    try {
      const response = await fetch(`${URL}/v1/member/get-members-list`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code == 200) {
        setCollaborateData(data.data);
        if (data.data) {
          const { members, permissions } = data.data;

          const transformAssign = members.map((member) => ({
            id: String(member.id),
            name: member.name,
            email: member.email,
            avatar: member.profile_image,
            permission:
              permissions.find((p) => p.id === member.permission_id)
                ?.label_name || "Can View",
          }));

          const transformedCollaborators = members.map((member) => ({
            id: String(member.id),
            name: member.invitee_nickname,
            email: member.email,
            avatar: member.profile_image,
          }));

          const transformPermission = permissions;

          setAssignData(transformAssign);
          setDummyCollaborators(transformedCollaborators);
          setPermission(transformPermission);
        }
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchCollabaroteDate();
  }, []);
  useEffect(() => {
    if (priority.length > 0 && uploadedData.priority) {
      const matchedPriority = priority.find(
        (p) => p.label_name.toLowerCase() == uploadedData.priority.toLowerCase()
      );

      // console.log("Uploaded Priority:", uploadedData.priority);
      // console.log("Matched Priority ID:", matchedPriority?.id);

      setSelectedPriorityIds(matchedPriority?.id || null);
    }
  }, [priority, uploadedData]);

  const formatDateTimeRem = (selectedDate, selectedTime, selectedReminder) => {
    const validReminderMap = {
      5: "5 minute before",
      30: "30 minute before",
      60: "1 hour before",
      1440: "1 day before",
    };

    const formattedDate = moment(selectedDate, [
      "D MMMM YYYY",
      "DD, MMMM YYYY",
      "YYYY-MM-DD",
      "MM/DD/YYYY",
      "DD MMM YYYY",
    ]);

    if (!formattedDate.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid date" };
    }

    const formattedStartTime = moment(selectedTime?.start, [
      "HH:mm",
      "HH:mm:ss",
    ]);
    if (!formattedStartTime.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid time" };
    }

    const taskStart = moment.utc(
      `${formattedDate.format("YYYY-MM-DD")}T${formattedStartTime.format(
        "HH:mm"
      )}:00Z`
    );

    const taskStartTime = taskStart.format("YYYY-MM-DDTHH:mm:ss[Z]");
    const reminderTime = moment.utc(selectedReminder);

    if (!reminderTime.isBefore(taskStart)) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const diffMinutes = taskStart.diff(reminderTime, "minutes");

    if (validReminderMap[diffMinutes]) {
      return { taskStartTime, reminderText: validReminderMap[diffMinutes] };
    }

    // Compute human-readable fallback for Customize...
    const totalMinutes = diffMinutes;
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    let parts = [];
    if (days > 0) parts.push(`${days} day${days > 1 ? "s" : ""}`);
    if (hours > 0) parts.push(`${hours} hour${hours > 1 ? "s" : ""}`);
    if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);

    const customizeLabel =
      parts.length > 0 ? `${parts.join(", ")} before` : "Customize...";

    return { taskStartTime, reminderText: customizeLabel };
  };
  const handleSelectReminder = (reminder) => {
    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      reminder
    );
    setSelectedReminder(reminder);
    setDescSelectedReminder(reminderText);
    setSwitchStatesRem(!!reminder);

    // console.log("SelectedReminder>>", reminder);
  };

  const getCalenderMetaData = async () => {
    try {
      const response = await fetch(`${URL}/v1/calendar/get-calendar-metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code == 200) {
        setPriority(data.data.priority);
        setRadioMeta(data.data.progress_status);
        setColorMetaData(data.data.colors);
        setPermission(data.data.permissions);
        setRepeatOption(data.data.repeat_option);
        setAdjustWeekend(data.data.adjust_weekends);
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      // console.log("response>>>>>", data);
    } catch (error) {}
  };

  useEffect(() => {
    getCalenderMetaData();
  }, []);

  const [pdfUrl, setPdfUrl] = useState(null);
  const [inviteCaptureId, setInviteCaptureId] = useState(null);

  const [step, setStep] = useState(1); // Track modal step

  const handleCancel = async () => {
    if (!inviteCaptureId) {
      message.error("No invite to cancel!");
      return;
    }

    try {
      const response = await fetch(`${URL}/v1/invite-capture/cancel`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ invite_capture_id: inviteCaptureId }),
      });

      const data = await response.json();
      // console.log("Cancel Response:", data);

      if (data.code === 200) {
        message.success("Invite canceled successfully!");
        setInviteCaptureId(null); // Remove invite ID after cancellation
        closeModal();
      } else {
        message.error("Failed to cancel invite!");
      }
    } catch (error) {
      console.error("Cancel Error:", error);
      message.error("Something went wrong while canceling!");
    }
  };

  // const showModal = () => {
  //   setIsModalOpen(true);
  // };
  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };
  // const handleCancel = () => {
  //   setIsModalOpen(false);
  // };

  const handleRadioChange = (e) => {
    setSelectedStatus(e.target.value);
  };
  const getTabName = (key) => (key == "1" ? "task" : "event");

  const tabName = getTabName(activeTab);
  const descSelectedCollaboration =
    selectedCollaborators.length > 0 || (invitees?.length ?? 0) > 0
      ? [
          ...selectedCollaborators.map((c) => c.name),
          ...(invitees || []).map((i) => i.email.split("@")[0]),
        ].join(", ")
      : tabName === "event"
      ? "No participants selected"
      : "No collaborators selected";

  // This will log the description
  // console.log("Description of selected collaborators:", descSelectedCollaboration);
  // const handleSubmitNew = async () => {
  //   const getRepetitionEndDate = () => {
  //     if (!repeatConfig || !formattedStartDate) return null;

  //     const { endType, occurrences, customEndDate } = repeatConfig;

  //     if (endType === "custom" && customEndDate) {
  //       return moment(customEndDate).format("YYYY-MM-DD");
  //     }

  //     return moment(formattedStartDate)
  //       .add(occurrences, "years")
  //       .format("YYYY-MM-DD");
  //   };
  //   // console.log(
  //     "Current title before submitting:",
  //     title,
  //     selectedStatus,
  //     note
  //   );
  //   const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
  //     "YYYY-MM-DD"
  //   );
  //   let formattedDate = moment(
  //     formattedStartDate,
  //     ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
  //     true
  //   );

  //   if (!formattedDate.isValid()) {
  //     formattedDate = moment(
  //       selectedDate,
  //       ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
  //       true
  //     );
  //   }

  //   let formattedStartTime = selectedTime?.start
  //     ? moment(selectedTime.start, ["HH:mm", "HH:mm:ss"], true).format("HH:mm")
  //     : "00:00";

  //   let formattedEndTime = selectedTime?.end
  //     ? moment(selectedTime.end, ["HH:mm", "HH:mm:ss"], true).format("HH:mm")
  //     : "23:59";

  //   const taskStartTime = moment
  //     .utc(`${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime}`)
  //     .format("YYYY-MM-DDTHH:mm:ss[Z]");

  //   const taskEndTime = moment
  //     .utc(`${formattedDate.format("YYYY-MM-DD")} ${formattedEndTime}`)
  //     .format("YYYY-MM-DDTHH:mm:ss[Z]");

  //   const formattedReminder = selectedReminder
  //     ? moment(selectedReminder, "YYYY-MM-DD HH:mm").format(
  //         "YYYY-MM-DDTHH:mm:ss[Z]"
  //       )
  //     : null;
  //   const transformedCollaborators = selectedCollaborators.map((collab) => ({
  //     member_id: Number(collab.id),
  //     permission_id: String(collab.permission?.id),
  //   }));
  //   const hasSaturday = repeatConfig?.excludeWeekends?.some(
  //     (w) => w.label === "saturday"
  //   );
  //   const hasSunday = repeatConfig?.excludeWeekends?.some(
  //     (w) => w.label === "sunday"
  //   );
  //   let adjustWeekendsValue = null;

  //   if (repeatConfig?.adjustWeekends) {
  //     if (hasSaturday && hasSunday) {
  //       adjustWeekendsValue = "previous_friday";
  //     } else if (hasSaturday) {
  //       adjustWeekendsValue = "previous_friday";
  //     } else if (hasSunday) {
  //       adjustWeekendsValue = "previous_saturday";
  //     }
  //   }
  //   if (title.trim() === "" || !title) {
  //     message.error("Title is required");
  //     return;
  //   }
  //   if (!selectedDate || selectedDate === "Event date is in the past") {
  //     message.error("Date is required");
  //     return;
  //   }
  //   if (!selectedTime?.start || !selectedTime?.end) {
  //     message.error("Start and End time are required");
  //     return;
  //   }
  //   if (location.trim() === "" || !location) {
  //     message.error("Location is required");
  //     return;
  //   }
  //   if (!selectedPriorityIds) {
  //     message.error("Priority is required");
  //     return;
  //   }
  //   if (!selectedStatus) {
  //     message.error("Status is required");
  //     return;
  //   }
  //   const eventPayload = {
  //     title: title,
  //     location: location,
  //     // description: inputTextDesc,
  //     // display_name_id: selectedDisplayId,
  //     priority_id: selectedPriorityIds,
  //     progress_status_id: 26,
  //     status: selectedStatus,
  //     start_date: formattedStartDate,
  //     start_time: taskStartTime,
  //     end_time: taskEndTime,
  //     invite_capture_id: inviteCaptureId,
  //     is_rescanning: 0,
  //     user_id: userId,
  //     reminder_timestamp:
  //       selectedReminder != "No reminder" ? formattedReminder : null,
  //     participants: transformedCollaborators,
  //     repeat_option: repeatConfig?.repeatType?.value || null,
  //     repetition_end_date: getRepetitionEndDate(),
  //     exclude_saturdays:
  //       repeatConfig &&
  //       repeatConfig.excludeWeekends &&
  //       repeatConfig.excludeWeekends.length
  //         ? repeatConfig.excludeWeekends.some((w) => w.label === "saturday")
  //         : 0,
  //     exclude_sundays:
  //       repeatConfig &&
  //       repeatConfig.excludeWeekends &&
  //       repeatConfig.excludeWeekends.length
  //         ? repeatConfig.excludeWeekends.some((w) => w.label === "sunday")
  //         : 0,
  //     adjust_weekends: adjustWeekendsValue,
  //     color_id: selectedColorForPayload || null,
  //     invitees: invitees,
  //     note: note || null,
  //     // check_list: checkListItems,  // If event-related, include checklist
  //   };

  //   // console.log("Final Payload:", eventPayload);
  //   // return
  //   try {
  //     const response = await fetch(`${URL}/v1/event/create`, {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //         "Cache-Control": "no-cache",
  //       },
  //       body: JSON.stringify(eventPayload),
  //     });

  //     const data = await response.json();
  //     if (data.code === 200) {
  //       message.success("Invite capture created successfully");
  //       // resetFormFields();
  //       closeModal(false);
  //       getData();

  //       // Clear form fields and state after successful submission
  //     } else {
  //       // console.log("data", data);
  //       message.error(data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  const handleSubmitNew = async (update_type = "all", occurrenceDate) => {
    // setSubmitLoading(true);
    const getRepetitionEndDate = () => {
      if (!repeatConfig || !formattedStartDate) return null;

      const { endType, occurrences, customEndDate } = repeatConfig;

      if (endType === "custom" && customEndDate) {
        return moment(customEndDate).format("YYYY-MM-DD");
      }

      return moment(formattedStartDate)
        .add(occurrences, "years")
        .format("YYYY-MM-DD");
    };
    const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
      "YYYY-MM-DD"
    );
    let formattedDate = moment(
      formattedStartDate,
      ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
      true
    );

    if (!formattedDate.isValid()) {
      formattedDate = moment(
        selectedDate,
        ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
        true
      );
    }

    if (!selectedPriorityIds) {
      message.error("Please select priority");
      return;
    }

    let formattedStartTime = selectedTime?.start
      ? moment(selectedTime.start, ["HH:mm", "HH:mm:ss"], true).format("HH:mm")
      : "00:00";

    let formattedEndTime = selectedTime?.end
      ? moment(selectedTime.end, ["HH:mm", "HH:mm:ss"], true).format("HH:mm")
      : "23:59";

    const taskStartTime = moment
      .utc(`${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime}`)
      .format("YYYY-MM-DDTHH:mm:ss[Z]");

    const taskEndTime = moment
      .utc(`${formattedDate.format("YYYY-MM-DD")} ${formattedEndTime}`)
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    const formattedReminder = moment(
      selectedReminder,
      "YYYY-MM-DD HH:mm"
    ).format("YYYY-MM-DDTHH:mm:ss[Z]");
    // console.log("selectedCollaborators", selectedCollaborators)
    const transformedCollaborators = selectedCollaborators.map((collab) => ({
      member_id: Number(collab.id || collab.member_id),
      permission_id: String(
        collab.permission?.id || collab.permission_id || collab.permission
      ),
    }));
    const hasSaturday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "saturday"
    );
    const hasSunday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "sunday"
    );
    let adjustWeekendsValue = null;

    if (repeatConfig?.adjustWeekends) {
      if (hasSaturday && hasSunday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSaturday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSunday) {
        adjustWeekendsValue = "previous_saturday";
      }
    }

    const eventPayload = {
      title: title,
      location: location || null,
      status: selectedStatus,
      start_date: formattedStartDate,
      start_time: taskStartTime,
      priority_id: selectedPriorityIds,
      end_time: taskEndTime,
      reminder_timestamp: switchStatesRem ? formattedReminder : null,
      invite_capture_id: inviteCaptureId ? Number(inviteCaptureId) : 0, // Convert to number
      is_rescanning: 0,
      is_rescan_save: 1,
      // note: noteNew || null,
      participants: transformedCollaborators,
      repeat_option: repeatConfig?.repeatType?.value || null,
      ...(update_type !== "all" && { occurrence_date: occurrenceDate }),
      // update_type: repeatConfig?.repeatType?.value ? update_type : "all",
      color_id: selectedColorForPayload || null,
      exclude_saturdays:
        repeatConfig &&
        repeatConfig.excludeWeekends &&
        repeatConfig.excludeWeekends.length
          ? repeatConfig.excludeWeekends.some((w) => w.label === "saturday")
          : 0,
      exclude_sundays:
        repeatConfig &&
        repeatConfig.excludeWeekends &&
        repeatConfig.excludeWeekends.length
          ? repeatConfig.excludeWeekends.some((w) => w.label === "sunday")
          : 0,
      repetition_end_date:
        update_type == "current"
          ? null
          : repeatConfig?.endType === "custom"
          ? moment(repeatConfig.customEndDate).format("YYYY-MM-DD")
          : getRepetitionEndDate(),
      adjust_weekends: adjustWeekendsValue,
      invitees: invitees,
    };
    // console.log("eventPayload", eventPayload);
    // return
    try {
      const response = await fetch(`${URL}/v1/invite-capture/update`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(eventPayload),
      });
      const data = await response.json();

      if (!response.ok) {
        // setSubmitLoading(false);
        // Show all backend errors if present
        if (data.errors) {
          Object.values(data.errors)
            .flat()
            .forEach((err) => message.error(err));
        } else if (data.message) {
          message.error(data.message);
        } else {
          message.error(
            `Failed to update invite capture. (${response.status})`
          );
        }
        console.error(
          `HTTP Error: ${response.status} ${response.statusText}`,
          data
        );
        return;
      }

      if (data.code === 200) {
        message.success("Invite capture created successfully");
        // setSubmitLoading(false);
        setDateRange([]);
        setSearchTerm("");
        setSelectedTab("all");
        closeModal(false);
      } else {
        // setSubmitLoading(false);
        // Show all backend errors if present
        if (data.errors) {
          Object.values(data.errors)
            .flat()
            .forEach((err) => message.error(err));
        } else if (data.message) {
          message.error(data.message);
        } else {
          message.error("Failed to update invite capture.");
        }
        console.error("API error:", data);
      }
    } catch (error) {
      // setSubmitLoading(false);
      console.error("Fetch Error:", error);
      message.error("Network error! Please try again.");

      // Check if it's a CORS issue
      if (error.message.includes("Failed to fetch")) {
        console.error("Possible CORS issue. Check Laravel settings.");
      }
    }
  };

  const handleSwitchChangeRem = () => {
    // console.log("handleSwitchChangeRem::", switchStatesRem);
    if (
      !selectedDate ||
      selectedDate === "Event date is in the past, Please select a valid date"
    ) {
      message.error("Please select a valid date before setting a reminder.");
      return;
    }
    if (!selectedTime?.start || !selectedTime?.end) {
      message.error(
        "Please select start and end time before setting a reminder."
      );
      return;
    }

    const newState = !switchStatesRem;
    // console.log(newState);

    if (newState) {
      // Trying to turn ON → open modal first
      setShowRemModal(true);
    } else {
      // Turning OFF → reset reminder
      setDescSelectedReminder("No reminder");
      setSwitchStatesRem(false);
    }
  };
  const handleRemModalClose = () => {
    if (!descSelectedReminder || descSelectedReminder === "No reminder") {
      setSwitchStatesRem(false); // Reset switch if nothing chosen
    }
    setShowRemModal(false);
  };

  const beforeUpload = (file) => {
    const isAllowedType = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/svg+xml",
    ].includes(file.type);
    if (!isAllowedType) {
      message.error("Only JPEG, PNG, JPG, and SVG files are allowed!");
      return Upload.LIST_IGNORE;
    }
    // const isLt2M = file.size / 1024 / 1024 < 2; // Convert bytes to MB

    // if (!isLt2M) {
    //   message.error("File size must be smaller than 2MB!");
    //   return Upload.LIST_IGNORE; // Prevent upload
    //}

    handleImageUpload(file); // Pass file directly
    return false; // Stop default upload behavior
  };

  // Handle image upload & conversion to Base64
  const handleImageUpload = async (file) => {
    if (!file) return;
    setUploadedImage(file); // Store the uploaded image file

    // setIsUploading(true); // ✅ Start loader

    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/svg+xml",
    ];

    if (!allowedTypes.includes(file.type)) {
      message.warning("Only JPEG, PNG, JPG, and SVG files are allowed!");
      // setIsUploading(false); // ✅ Stop loader

      return;
    }

    const reader = new FileReader();

    reader.onload = async () => {
      setStep(3);
      const base64String = reader.result; // Full Data URL format
      setImageUrl(base64String); // Update image preview

      const payload = {
        invite_file: base64String,
      };

      try {
        const response = await fetch(`${URL}/v1/invite-capture/upload-invite`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        if (data.code == 200 && data.data?.captured_data?.length > 0) {
          message.success("Image uploaded successfully!");
          let eventData = data.data.captured_data[0];
          if (
            eventData.invite_file_path &&
            eventData.invite_file_path.toLowerCase().endsWith(".pdf")
          ) {
            eventData.is_pdf = 1;
          } else {
            eventData.is_pdf = 0;
          }
          setUploadedData(eventData); // Store API response
          const eventDate = moment(eventData.start_date);
          const today = moment();
          const tomorrow = moment().add(1, "day");
          const todays = moment().startOf("day");

          let prefix = "";
          if (eventDate.isSame(today, "day")) {
            prefix = "Today, ";
          } else if (eventDate.isSame(tomorrow, "day")) {
            prefix = "Tomorrow, ";
          }

          if (eventDate.isSameOrAfter(todays)) {
            setSelectedDate(eventDate.format("DD MMMM YYYY"));
          } else {
            message.warning(
              "Event date is in the past, Please select a valid date"
            );
            setSelectedDate(
              "Event date is in the past, Please select a valid date"
            );
          }
          // setSelectedDate(eventDate.format("DD MMMM YYYY"));
          if (eventData?.start_time && eventData?.end_time) {
            const start = moment.utc(eventData.start_time).format("HH:mm");
            const end = moment.utc(eventData.end_time).format("HH:mm");

            setSelectedTime({ start, end });
            setFormattedTime(`${start} - ${end}`);
          }
          if (eventData?.title) {
            setTitle(eventData.title); // Correct way to set the title
          }
          if (eventData?.location) {
            setLocation(eventData.location);
          }
          if (eventData?.invite_capture_id) {
            setInviteCaptureId(eventData.invite_capture_id);
          }
          if (eventData?.user_id) {
            setUserId(eventData.user_id);
          }
          if (eventData?.user_id) {
            setUserId(eventData.user_id);
          }
          setStep(4);
        } else {
          message.error("Upload failed!");
          setStep(2);
        }
      } catch (error) {
        console.error("Upload error:", error);
        message.error("Something went wrong!");
      } finally {
        // setIsUploading(false);
        // ✅ Stop loader
      }
    };

    reader.readAsDataURL(file); // Convert to Base64
  };

  const beforeUploadPdf = (file) => {
    if (file.type !== "application/pdf") {
      message.warning("Only PDF files are allowed!");
      return Upload.LIST_IGNORE;
    }

    // const isLt2M = file.size / 1024 / 1024 < 2; // Convert bytes to MB
    // if (!isLt2M) {
    //   message.error("PDF size must be smaller than 2MB!");
    //   return Upload.LIST_IGNORE;
    // }

    handlePdfUpload(file);
    return false; // Stop default uploa
  };
  const handleDateChange = (date) => {
    // console.log("date change", date);
    setSelectedDate(date);
  };
  const handleTimeChange = (time) => {
    // console.log("time change", time);
    setSelectedTime(time);
  };
  const handleLocationChange = (newLocation) => {
    // console.log("Locationnew", newLocation);
    setLocation(newLocation);
  };
  const handlePdfUpload = async (file) => {
    if (!file) return;
    setUploadedPdf(file); // Store the uploaded PDF file

    setIsUploading(true); // ✅ Start loader
    setStep(3);
    const formData = new FormData();
    formData.append("invite_file", file); // ✅ Send file directly

    try {
      const response = await fetch(`${URL}/v1/invite-capture/upload-invite`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: formData, // ✅ Send FormData
      });
      const data = await response.json();

      if (data.code == 200 && data.data?.captured_data?.length > 0) {
        message.success("Pdf uploaded successfully!");
        let eventData = data.data.captured_data[0];
        if (
          eventData.invite_file_path &&
          eventData.invite_file_path.toLowerCase().endsWith(".pdf")
        ) {
          eventData.is_pdf = 1;
        } else {
          eventData.is_pdf = 0;
        }
        setUploadedData(eventData); // Store API response
        setImageUrl(data.fileUrl); // ✅ Set the PDF preview URL

        // console.log("data.data.captured_data:::::::", eventData);
        const eventDate = moment(eventData.start_date);
        const today = moment();
        const tomorrow = moment().add(1, "day");
        const todays = moment().startOf("day");
        let prefix = "";
        if (eventDate.isSame(today, "day")) {
          prefix = "Today, ";
        } else if (eventDate.isSame(tomorrow, "day")) {
          prefix = "Tomorrow, ";
        }
        if (eventDate.isSameOrAfter(todays)) {
          setSelectedDate(eventDate.format("DD MMMM YYYY"));
        } else {
          message.warning(
            "Event date is in the past, Please select a valid date"
          );
          setSelectedDate(
            "Event date is in the past, Please select a valid date"
          );
        }
        if (eventData?.start_time && eventData?.end_time) {
          const start = moment.utc(eventData.start_time).format("HH:mm");
          const end = moment.utc(eventData.end_time).format("HH:mm");

          setSelectedTime({ start, end });
          // console.log("setSelectedTime called with:", { start, end });

          setFormattedTime(`${start} - ${end}`);
        }
        if (eventData?.title) {
          // console.log("eventData.title:::::::::", eventData.title);
          setTitle(eventData.title); // Correct way to set the title
        }
        // console.log("Uploaded Image URL:", data.fileUrl);
        if (eventData?.location) {
          setLocation(eventData.location);
        }
        if (eventData?.invite_capture_id) {
          setInviteCaptureId(eventData.invite_capture_id);
        }
        if (eventData?.user_id) {
          setUserId(eventData.user_id);
        }
        if (eventData?.user_id) {
          setUserId(eventData.user_id);
        }
        setStep(4); // Store API response

        // console.log("Uploaded PDF URL:", data.fileUrl);
      } else {
        message.error("PDF upload failed!");
        setStep(2);
      }
    } catch (error) {
      console.error("Upload error:", error);
      message.error("Something went wrong!");
    } finally {
      setIsUploading(false); // ✅ Stop loader
    }
  };

  const canProceedToStep3 = uploadedImage !== null || uploadedPdf !== null;

  const handleSelectPriority = async (priorityId) => {
    setSelectedPriorityIds(priorityId); // Update UI immediately
  };
  const handleSaveCollaboration = (selected) => {
    // console.log("Selected collaborators before state update:", selected);

    // Separate new invitees
    const newInvites = selected.filter((user) => user.newInvitee);
    const confirmedCollaborators = selected.filter((user) => !user.newInvitee);

    // Set only confirmed collaborators
    setSelectedCollaborators(confirmedCollaborators);
    setSwitchStatesCollaboration(confirmedCollaborators.length > 0);
    setShowCollaborationModal(false);

    // Add new confirmed collaborators to dummyCollaborators if not already present
    const newCollaborators = confirmedCollaborators.filter(
      (sel) => !dummyCollaborators.some((c) => c.id === sel.id)
    );

    if (newCollaborators.length > 0) {
      setDummyCollaborators((prev) => [...prev, ...newCollaborators]);
    }

    // Extract and set unique invitees
    if (newInvites.length > 0) {
      const invitePayload = newInvites.map((invitee) => ({
        email: invitee.email,
        permission_id: String(invitee.permission.id),
      }));

      setInvitees((prev = []) => {
        const existingEmails = new Set(prev.map((i) => i.email));
        const filteredNew = invitePayload.filter(
          (i) => !existingEmails.has(i.email)
        );
        return [...prev, ...filteredNew];
      });
    }
  };
  const selectTextReminder = (item) => {
    // console.log("nananan", item);
    setDescSelectedReminder(item);
  };
  const handleTitleChange = (newTitle) => {
    setTitle(newTitle);
    // console.log("setTitle", newTitle);
  };

  return (
    <div>
      {/* <Button type='primary' onClick={showModal}>
        Open Modal
      </Button> */}
      <Modal
        maskClosable={false}
        closable={true}
        title={
          <div style={{ textAlign: "left", fontWeight: 600 }}>
            Invite Capture
          </div>
        }
        open={showModal}
        onCancel={closeModal}
        footer={false}
        width={634}
        className="custom-modal"
      >
        {step === 1 && (
          <>
            <div className="modal-content">
              <h2 className="modal-title">
                Capture & Organise Your <br /> Invitations
              </h2>
              <p className="modal-description">
                Easily scan invitations from emails, images or paper copies and
                add them directly to your calendar.
              </p>
              <p className="modal-description">
                No need to manually type out details from every birthday party
                or event invite that comes home in a child’s backpack. With
                Invite Capture, you simply snap a photo or upload a PDF, and
                Quelld’s smart OCR technology reads the text, identifies key
                info, and creates a calendar entry in seconds.
              </p>
              <img
                src={inviteCapture}
                width={130}
                style={{ marginBottom: "10px" }}
              />

              <Button
                type="primary"
                className="modal-btn"
                onClick={() => setStep(2)}
              >
                Start Capturing
              </Button>
              {/* <Button className='modal-btn'>Learn More</Button> */}
              {/* <LearnMoreModal
                moduleName="invite_capture"
                buttonType="default"
                buttonClass="modal-btn"
              /> */}
            </div>
          </>
        )}
        {step === 2 && (
          <>
            <div
              className={`modal-content ${isUploading ? "blur-effect" : ""}`}
            >
              <img
                src={inviteCapture}
                width={130}
                style={{ marginBottom: "10px", marginTop: "119px" }}
              />

              <h2 className="modal-title-step2">
                How Do You Want to Capture Your Invite?
              </h2>

              <div className="capture-options">
                <Upload
                  showUploadList={false}
                  maxCount={1} // Limits to one file
                  beforeUpload={beforeUpload}
                  accept="image/jpeg,image/png,image/jpg,image/svg+xml"
                >
                  <Button
                    className="step2-btn"
                    onClick={() => handleImageUpload}
                  >
                    Capture Image
                  </Button>
                </Upload>
                <Upload
                  showUploadList={false}
                  maxCount={1} // Limits to one file
                  beforeUpload={beforeUploadPdf}
                  accept="application/pdf"
                >
                  <Button className="step2-btn" onClick={() => handlePdfUpload}>
                    Upload File
                  </Button>
                </Upload>
              </div>

              <Button
                className="modal-btn purple-btn"
                onClick={() => setStep(3)}
                disabled={!canProceedToStep3} // Disable if no file uploaded
              >
                Continue
              </Button>
              <Button
                className="modal-btn purple-btn"
                onClick={() => setStep(1)}
              >
                Back
              </Button>
            </div>
            {isUploading && (
              <div className="loader-overlay">
                <Spin size="large" tip="Uploading..." />
              </div>
            )}
          </>
        )}
        {step === 3 && (
          <>
            <div className="modal-content">
              <h2 className="modal-title-step2 proccessing-title">
                Processing your Invite
              </h2>
            </div>
          </>
        )}
        {step === 4 && (
          <>
            <div className="modal-content">
              <div className="invite-preview-wrapper">
                {/* Image Preview */}
                {uploadedData?.is_pdf == 1 ? (
                  <iframe
                    src={`${uploadedData.invite_file_path}#toolbar=0&navpanes=0&scrollbar=0`}
                    width="100%"
                    height="500px"
                    // style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                    // title="PDF Preview"
                  />
                ) : (
                  <>
                    <Image
                      src={imageUrl}
                      className="invite-preview-image"
                      preview={false}
                    />

                    <input
                      type="file"
                      accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                      style={{ display: "none" }}
                      id="fileInput"
                      onChange={(e) => handleImageUpload(e.target.files[0])}
                    />
                  </>
                )}

                {/* Hidden File Input for Editing */}
                {uploadedData?.is_pdf && (
                  <input
                    type="file"
                    accept="application/pdf"
                    style={{ display: "none" }}
                    id="fileInput"
                    onChange={(e) => handlePdfUpload(e.target.files[0])}
                  />
                )}
                <Button
                  type="primary"
                  shape="square"
                  className="editImageBtn"
                  icon={<EditOutlined />}
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    zIndex: 10,
                    background: "#fef1fe",
                    borderColor: "#9a4fe0",
                    color: "#9a4fe0",
                  }}
                  onClick={() => document.getElementById("fileInput").click()} // Trigger file input
                />
              </div>
              <div>
                <div className="invite-container">
                  <EditableField
                    icon={<TitleOutlined />}
                    label={
                      <span>
                        Event Title <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    isRequired={true}
                    value={title}
                    onSave={handleTitleChange}
                    type="text"
                  />
                  <EditableField
                    icon={<CalendarOutlined />}
                    label={
                      <span>
                        Date <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    value={selectedDate}
                    type="date"
                    onSave={handleDateChange}
                  />
                  <EditableField
                    icon={<ClockCircleOutlined />}
                    label={
                      <span>
                        Time <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    value={
                      selectedTime.start && selectedTime.end
                        ? `${selectedTime.start} - ${selectedTime.end}`
                        : "Not Set"
                    }
                    type="time"
                    onSave={handleTimeChange}
                  />
                  <EditableField
                    icon={<LocationOn />}
                    label={
                      <span>
                        Location <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    value={location || "NA"}
                    onSave={handleLocationChange}
                    type="text"
                  />
                </div>
              </div>
              <div className="invite-container">
                <div className="invite-section-heading">
                  <span>
                    Priority <span style={{ color: "red" }}>*</span>
                  </span>
                </div>
                <div className="invite-priority-tags">
                  {priority.length > 0 ? (
                    priority.map((status) => (
                      <Tag
                        onClick={() => handleSelectPriority(status.id)}
                        style={{
                          backgroundColor:
                            selectedPriorityIds === status.id
                              ? "#FEF1FE"
                              : "#ffffff",
                          color:
                            selectedPriorityIds === status.id
                              ? "#9A4FE0"
                              : "#000",
                          border:
                            selectedPriorityIds === status.id
                              ? "1px solid #9A4FE0"
                              : "1px solid #E1E6EF",
                          borderRadius: "10px",
                          cursor: "pointer",
                          fontSize: "14px",
                          padding: "8px 12px",
                          lineHeight: "18px",
                        }}
                        key={status.id}
                      >
                        {status.label_name}
                      </Tag>
                    ))
                  ) : (
                    <p>Loading...</p> // Optional loading state
                  )}
                </div>
              </div>

              <div className="invite-capture-status" style={{ width: "100%", padding: "12px" }}>
                <div className="invite-section-heading">
                  <span>
                    Status <span style={{ color: "red" }}>*</span>
                  </span>
                </div>

                <Radio.Group
                  className="custom-radio-group invite-status-options"
                  onChange={handleRadioChange}
                  defaultValue="pending"
                  value={selectedStatus} // ✅ Ensure the state is reflected
                >
                  <Radio value="pending confirmation" className="custom-radio">
                    Pending Confirmation
                  </Radio>
                  <Radio value="confirmed" className="custom-radio">
                    Confirmed
                  </Radio>
                </Radio.Group>
              </div>

              <div className="invite-details-list">
                <DetailsList
                  icon={
                    <BellOutlined
                      style={{ fontSize: 20, color: "#666", marginRight: 6 }}
                    />
                  }
                  title="Reminder"
                  description={descSelectedReminder}
                  switchChecked={switchStatesRem}
                  onSwitchChange={handleSwitchChangeRem}
                  onClick={() => setShowRemModal(true)}
                />

                {/* Collaboration */}
                <DetailsList
                  icon={<AssessmentOutlined />}
                  title="Participants"
                  description={descSelectedCollaboration}
                  switchChecked={switchStatesCollaboration}
                  onSwitchChange={() => setShowCollaborationModal(true)}
                  onClick={() => setShowCollaborationModal(true)}
                />

                {/* Repeat */}
                <DetailsList
                  icon={<RepeatOnOutlined />}
                  title="Repeat"
                  description={descSelectedRepeat}
                  switchChecked={switchStatesRepeat}
                  onSwitchChange={() => setShowRepeatModal(true)}
                  onClick={() => setShowRepeatModal(true)}
                />

                {/* Color */}
                <DetailsList
                  icon={<ColorLensOutlined />}
                  title="Color"
                  description={descSelectedColor}
                  switchChecked={switchStatesColor}
                  onSwitchChange={() => setShowColorModal(true)}
                  onClick={() => setShowColorModal(true)}
                />
              </div>

              <div style={{ width: "-webkit-fill-available" }}>
                <div className="invite-section-heading notes-label">
                  <p>Note (Optional)</p>
                </div>

                <Input.TextArea
                  placeholder="Enter your notes here..."
                  rows={3} // Adjust the height of the text area
                  allowClear // Adds a clear button inside the input
                  value={note} // Binds to state
                  onChange={(e) => setNote(e.target.value)} // Updates state on input change
                />
              </div>
              <div className="invite-footer-actions">
                <Button onClick={handleCancel} className="modal-cancel-btn">
                  Cancel
                </Button>
                <Button
                  type="primary"
                  className="modal-success-btn"
                  onClick={handleSubmitNew}
                >
                  Review & Confirm
                </Button>
              </div>
            </div>
          </>
        )}
      </Modal>

      <div>
        <div>
          {showRemModal && (
            <Reminder
              show={showRemModal}
              handleClose={handleRemModalClose}
              onSelectReminder={handleSelectReminder}
              eventDate={selectedDate}
              eventTime={selectedTime}
              selectReminderTime={selectTextReminder}
              initialReminder={descSelectedReminder}
            />
          )}
          {showCollaborationModal && (
            <CollaborationModal
              visible={showCollaborationModal}
              onCancel={() => setShowCollaborationModal(false)}
              onSave={handleSaveCollaboration}
              collaborators={dummyCollaborators}
              initialSelected={selectedCollaborators}
              permissionMetadata={permission}
              tabName={tabName} // <-- Pass the tab name here
            />
          )}

          {showRepeatModal && (
            <RepeatModal
              visible={showRepeatModal}
              onCancel={() => setShowRepeatModal(false)}
              repeatOption={repeatOption}
              adjustWeeknd={adjusWeekend}
              onSave={(repeatData) => {
                setRepeatConfig(repeatData);
                setDescSelectedRepeat(
                  repeatData?.repeatType?.label_name
                    ? repeatData.repeatType.label_name
                    : "No repeat"
                );
                setSwitchStatesRepeat(!!repeatData?.repeatType);
                setShowRepeatModal(false);
              }}
              initialValues={repeatConfig}
            />
          )}

          {showColorModal && (
            <ColorsModal
              visible={showColorModal}
              onCancel={() => setShowColorModal(false)}
              metaData={colorMetaData}
              onSave={(color) => {
                setSelectedColorForPayload(color?.id);
                setDescSelectedColor(color?.label_name);
                setSwitchStatesColor(color?.id ? true : false);
                setShowColorModal(false);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default InviteCapture;
